import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useRazorpay } from "react-razorpay";
import { useCurrency } from "../context/CurrencyContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useCheckout = () => {
  const [loading, setLoading] = useState(null);
  const { Razorpay } = useRazorpay();
  const { currency } = useCurrency();

  const checkout = async (pkgId, pkgName) => {
    setLoading(pkgId);
    try {
      const { data } = await axios.post(`${API}/payments/checkout`, {
        package_id: pkgId,
        currency,
      });
      const rzp = new Razorpay({
        key: data.key_id,
        amount: data.amount,
        currency: data.currency,
        order_id: data.order_id,
        name: "Prisca Arcana",
        description: pkgName,
        theme: { color: "#D4AF37", backdrop_color: "#0A090B" },
        handler: async (resp) => {
          try {
            await axios.post(`${API}/payments/verify`, resp);
            window.location.href = `/payment/success?order_id=${data.order_id}`;
          } catch {
            toast.error("The seal could not be verified. If you were charged, contact the practitioner.");
            setLoading(null);
          }
        },
        modal: { ondismiss: () => setLoading(null) },
      });
      rzp.on("payment.failed", () => {
        toast.error("The tribute did not pass through. Please try again.");
        setLoading(null);
      });
      rzp.open();
    } catch (e) {
      if (e.response?.status === 503) {
        toast.info("The payment portal is being consecrated. Send a petition below and the practitioner will arrange your working directly.", { duration: 6000 });
        document.getElementById("enquiry")?.scrollIntoView({ behavior: "smooth" });
      } else {
        toast.error("The payment portal faltered. Please try again.");
      }
      setLoading(null);
    }
  };

  return { checkout, loading };
};
